declare const FALLBACK_LOCALE;

import moment from 'moment';

export interface SkinDate {
    dateFIAF: string,
    empty: boolean,
    endInterval: any,
    startInterval: any,
    txt: string
}

export const toTimestamp = (date: string) => moment(date).unix()

export const toDateTxt = (date: string) => date ? moment(date).format('DD/MM/YYYY') : ""

export const toDateTxtHMS = (date: string) => date ? moment(date).format('DD/MM/YYYY hh:mm:ss') : ""

export const toInputDate = (reportDate) => moment(reportDate).format('YYYY-MM-DD');

export const getDateYear = (date: string) => moment(date).format("YYYY");

export function getReadableDate(date: string) {
    if (date && typeof date === "string") { // TODO do better when last date of cr is repaired in backend
        return date.split(" ")[0]
    }
    return ''
}

export function getCurrentDateAsSkinDate() {
    const dateTxt = toInputDate(moment.now());
    return buildSkinDate(dateTxt)
}

export function getCurrentDateTimeAsSkinDate() {
    return buildSkinDateFromTimeStamp(moment.now())
}

export function buildSkinDate(dateTxt: string): SkinDate {
    const timeStamp = moment(dateTxt).valueOf()
    return ({
        dateFIAF: "",
        empty: false,
        endInterval: null,
        startInterval: {
            date: timeStamp,
            unit: "day"
        },
        txt: dateTxt
    }) as SkinDate
}

export function buildSkinDateFromTimeStamp(timeStamp: number) {
    const dateTxt = toInputDate(timeStamp)
    return ({
        dateFIAF: "",
        empty: false,
        endInterval: null,
        startInterval: {
            date: timeStamp,
            unit: "day"
        },
        txt: dateTxt
    }) as SkinDate
}

export function formatDuration(duration, minutesLabel, secondsLabel) {
    let result = "";
    if (duration) {
        const formattedDuration = moment.duration(duration);
        if (formattedDuration.minutes()) {
            result += formattedDuration.minutes() + " " + minutesLabel + " "
        }
        if (formattedDuration.seconds()) {
            result += formattedDuration.seconds() + " " + secondsLabel
        }
    }
    return result
}

export function skinDateToInputDate(date: SkinDate) {
    if (date.startInterval.date) {
        return toInputDate(date.startInterval.date)
    }
    return "";
}

export function formatDateFromNow(date, locale: string = FALLBACK_LOCALE) {
    if (date) {
        const formattedDate: number = date;
        moment.locale(locale)
        return moment(formattedDate).fromNow();
    }
    return ""
}